module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "border1"
  }), _vm._v(" "), _c('h2', {
    staticClass: "h2s"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/preface#pre"
    }
  }, [_vm._v("Preface")]), _vm._v(" / "), _c('em', [_vm._v("Michael Dylan Foster and Ray Cashman")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/part1#part1"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("THE PROVOCATION")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter1#ch1"
    }
  }, [_vm._v("1"), _c('span', {
    staticClass: "space"
  }, [_vm._v("Folkloristics in the Twenty-First Century")])]), _vm._v(" / "), _c('em', [_vm._v("Alan Dundes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part2#part2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("RESPONSES")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter2#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2"), _c('span', {
    staticClass: "space"
  }, [_vm._v("America’s Antitheoretical Folkloristics")])]), _vm._v(" / "), _c('em', [_vm._v("Lee Haring")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter3#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3"), _c('span', {
    staticClass: "space"
  }, [_vm._v("The Sweep of Knowledge: The Politics of Grand and Local Theory in Folkloristics")])]), _vm._v(" / "), _c('em', [_vm._v("Gary Alan Fine")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter4#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4"), _c('span', {
    staticClass: "space"
  }, [_vm._v("What(’s) Theory?")])]), _vm._v(" / "), _c('em', [_vm._v("Margaret A. Mills")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter5#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5"), _c('span', {
    staticClass: "space"
  }, [_vm._v("The Philology of the Vernacular:")])]), _vm._v(" / "), _c('em', [_vm._v("Richard Bauman")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter6#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6"), _c('span', {
    staticClass: "space"
  }, [_vm._v("Humble Theory")])]), _vm._v(" / "), _c('em', [_vm._v("Dorothy Noyes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter7#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7"), _c('span', {
    staticClass: "space"
  }, [_vm._v("Grand Theory, Nationalism, and American Folklore")])]), _vm._v(" / "), _c('em', [_vm._v("John W. Roberts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter8#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8"), _c('span', {
    staticClass: "space"
  }, [_vm._v("There Is No Grand Theory in Germany, and for Good Reason")])]), _vm._v(" / "), _c('em', [_vm._v("James R. Dow")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part3#part3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("COMMENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter9#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9"), _c('span', {
    staticClass: "space"
  }, [_vm._v("What Theory Is")])]), _vm._v(" / "), _c('em', [_vm._v("Newton Garver")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10"), _c('span', {
    staticClass: "space"
  }, [_vm._v("Weak Theory in an Unfinished World")])]), _vm._v(" / "), _c('em', [_vm._v("Kathleen Stewart")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11"), _c('span', {
    staticClass: "space"
  }, [_vm._v("“Or in Other Words”: Recasting Grand Theory")])]), _vm._v(" / "), _c('em', [_vm._v("Kirin Narayan")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12"), _c('span', {
    staticClass: "space"
  }, [_vm._v("Disciplining Folkloristics")])]), _vm._v(" / "), _c('em', [_vm._v("Charles L. Briggs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/part4#part4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("AFTERWORDS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13"), _c('span', {
    staticClass: "space"
  }, [_vm._v("Reflections on Grand Theory, Graduate School, and Intellectual Ballast")])]), _vm._v(" / "), _c('em', [_vm._v("Chad Edward Buterbaugh")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14"), _c('span', {
    staticClass: "space"
  }, [_vm._v("Ten Years After")])]), _vm._v(" / "), _c('em', [_vm._v("Lee Haring")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index#ind",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2176abdc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 72
// module chunks = 0